module.exports = __webpack_public_path__ + "static/media/pharmacy.95d4b76a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/pharmacy.png
// module id = 13901
// module chunks = 0